import { v4 as uuid } from "uuid";
import { createSlice } from '@reduxjs/toolkit';
import {APP_STATE} from "@/actions/globalConst";
import { LocationHistoryModel } from "@/models/PPC/LocationHistoryModel";

export const initialState = {
  APP_STATE: APP_STATE.INIT,
  APP_PART: APP_STATE.LOGIN_PART,
  location: new LocationHistoryModel(),
  key: null
};

const ApplicationReducer = createSlice({
  name: 'Application',
  initialState,
  reducers: {
        resetApplicationKey(state, action) {
            if(action.payload.key) {
                state.key = action.payload.key;
            }
        },
        setLocation(state, action) {
            if(action.payload.location) {
              if(!state.location) {
                state.location = new LocationHistoryModel();
              }
               state.location.location = action.payload.location;
               state.location.urlParams = action.payload.urlParams;
            }
        },
        unAuthorized(state, action) {
            if(state.APP_PART != APP_STATE.LOGIN_PART) {
              state.APP_STATE = APP_STATE.READY_APP
              state.APP_PART = APP_STATE.LOGIN_PART
          }
        }
  },
  extraReducers(builder) {
      
    builder.addMatcher(
      (action) => action.type.endsWith('USER_CHECKAUTH/pending'),
      (state, action) => {
          state.APP_STATE = APP_STATE.LOADING_APP
       });

    builder.addMatcher(
      (action) => (!action.type.endsWith('USER_CHECKAUTH/pending') && action.type.endsWith('pending')),
      (state, action) => {
          state.APP_STATE = APP_STATE.LOADING_VIEW
       });

    builder.addMatcher(
      (action) => (action.type.endsWith('USER_CHECKAUTH/rejected') ),
      (state, action) => {
          state.APP_STATE = APP_STATE.READY_APP
          state.APP_PART = APP_STATE.LOGIN_PART
          
       });

    builder.addMatcher(
      (action) => (action.type.endsWith('USER_LOGOUT/fulfilled')  ),
      (state, action) => {
          state.APP_STATE = APP_STATE.READY_APP
          state.APP_PART = APP_STATE.LOGIN_PART
       });

    builder.addMatcher(
      (action) => (action.type.endsWith('USER_CHECKAUTH/fulfilled') || action.type.endsWith('USER_LOGIN/fulfilled') ),
      (state, action) => {
          state.APP_STATE = APP_STATE.READY_APP
          state.APP_PART = APP_STATE.DASHBOARD_PART
       });
       
       
       
    }
  
});
 
export const { unAuthorized, setLocation, resetApplicationKey } = ApplicationReducer.actions;
export default ApplicationReducer.reducer;
